"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/push-notifications.module"));
__export(require("./src/simple-notifications.module"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/angular2-notifications/dist/index.js
// module id = ../../../../angular2-notifications/dist/index.js
// module chunks = 15